/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrgUnitBranchListPathOrgUnitId, OrgOrgUnitBranchListStatus200 } from "../types/OrgOrgUnitBranchList.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgOrgUnitBranchList } from "../requests/orgOrgUnitBranchList.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgOrgUnitBranchListQueryKey = (org_unit_id?: MaybeRefOrGetter<OrgOrgUnitBranchListPathOrgUnitId>) =>
	[{ url: "/api/org/org-unit/:org_unit_id/branch/", params: { org_unit_id: org_unit_id } }] as const;

export type OrgOrgUnitBranchListQueryKey = ReturnType<typeof orgOrgUnitBranchListQueryKey>;

export function orgOrgUnitBranchListQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgOrgUnitBranchListPathOrgUnitId>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgOrgUnitBranchListQueryKey(org_unit_id);
	return queryOptions<OrgOrgUnitBranchListStatus200, ResponseErrorConfig<Error>, OrgOrgUnitBranchListStatus200>({
		enabled: () => !!toValue(org_unit_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgOrgUnitBranchList(toValue(org_unit_id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * {@link /api/org/org-unit/:org_unit_id/branch/}
 */
export function useOrgOrgUnitBranchList<
	TData = OrgOrgUnitBranchListStatus200,
	TQueryData = OrgOrgUnitBranchListStatus200,
	TQueryKey extends QueryKey = OrgOrgUnitBranchListQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgOrgUnitBranchListPathOrgUnitId>,
	options: {
		query?: Partial<UseQueryOptions<OrgOrgUnitBranchListStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgOrgUnitBranchListQueryKey(org_unit_id);

	const query = useQuery(
		{
			...orgOrgUnitBranchListQueryOptions(org_unit_id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgOrgUnitBranchListStatus200, ResponseErrorConfig<Error>, TData, OrgOrgUnitBranchListStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
